import { Pipe, PipeTransform } from '@angular/core';

/**
 * We will need this pipe because when backend send date it's in sydney timezone so when we see outside sydney timezone it will be wrong.
 *
 * Return the date without timezone.
 *
 */

@Pipe({
  name: 'removeTimezoneFromDate',
})
export class RemoveTimezoneFromDatePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      // remove the timezone after +/- with symbol
      return value?.includes('+') ? value?.split('+')[0] : value?.split('-')[0];
    }
    return value;
  }
}
